import { ChangeEvent, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useCheckPermission } from '../../../shared/Helpers/hooks';
import { Tab, TabsContainer } from '../../../shared/uiComponents/Tabs';
import { CustomInput, Text } from '../../../shared/uiComponents';
import { PERMISSIONS } from '../../../App/constants';

import BT from './BT';
import CredentialedBCBA from './credentialedBCBA';
import NotCredentialedBCBA from './notCredentialedBCBA';

const ProviderLists = () => {
	const ASSIGN_BCBA = useCheckPermission(PERMISSIONS.SOAPNOTE.ASSIGN_BCBA);
	const ASSIGN_RBT = useCheckPermission(PERMISSIONS.SOAPNOTE.ASSIGN_RBT);

	const data = [
		{
			id: 0,
			name: `BCBA - credentialed`,
			isAllowed: ASSIGN_BCBA.permissionGranted,
			panel: CredentialedBCBA,
		},
		{
			id: 1,
			name: `BCBA - not credentialed`,
			isAllowed: ASSIGN_BCBA.permissionGranted,
			panel: NotCredentialedBCBA,
		},
		{ id: 2, name: `BT`, isAllowed: ASSIGN_RBT.permissionGranted, panel: BT },
	];

	const headers = data.filter((x) => x.isAllowed).map((x) => x.name);
	const panels = data.filter((x) => x.isAllowed).map((x) => x.panel);

	const [tab, setTab] = useState<number>(0);
	const [params, setParams] = useSearchParams();
	const [searchString, setSearchString] = useState<string>('');

	const setTabType = (value: number) => {
		setTab(value);
		const searchParams = new URLSearchParams();
		setParams(searchParams, { replace: true });
		setSearchString('');
	};

	const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setSearchString(value);
	};

	useEffect(() => {
		const timeout = setTimeout(() => {
			params.set('search', searchString);
			setParams(params, { replace: true });
		}, 1000);

		return () => clearTimeout(timeout);
		// TODO - fix the dependency array
		// eslint-disable-next-line
	}, [searchString]);

	return (
		<>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
			>
				<TabsContainer>
					{Boolean(headers?.length) &&
						headers.map((header, index) => (
							<Tab
								onClick={() => setTabType(index)}
								key={`header-${index}`}
								id={`${index}`}
								selected={index === tab}
								style={{ cursor: 'pointer' }}
							>
								<Text title={header} type="psm" fontWeight={index === tab ? 'semiBold' : 'medium'} />
							</Tab>
						))}
				</TabsContainer>
				<CustomInput value={searchString} onChange={onSearchChange} placeholder="Search" style={{ marginTop: 0 }} />
			</div>
			{Boolean(panels?.length) &&
				panels.map((Panel, index) => (
					<div key={`panel-${index}`} hidden={tab !== index} className="marginTop16">
						{tab === index && <Panel />}
					</div>
				))}
		</>
	);
};

export default ProviderLists;
